import React from 'react';
import { Route } from 'react-router-dom';
import HomePage from './HomePage';
import PreviewPage from './PreviewPage';

export default [
  <Route path='/' component={HomePage} exact key='homepage' />,
  <Route path='/preview' component={PreviewPage} exact key='previewpage' />,
];
